module.exports = __webpack_public_path__ + "img/full1-min.ec6d93eb.png";